interface EnvironmentVariables {
  _buildID?: string;
  apiURL: string;
  basePath: string;
  cartCookieName: string;
  cdpURL: string;
  clickScriptURL: string;
  clickScriptIntegrity?: string;
  graphqlURL: string;
  hCaptchaKey: string;
  iovationScriptURL: string;
  isDevelopmentEnvironment: string;
  ocpGraphqlURL?: string;
  signInURL: string;
  mySparkDigitalSignInURL: string;
  trackingURL: string;
  errorRedirectDisabled: boolean;
  wwwUrl: string;
}

export const environmentVariables: EnvironmentVariables = {
  apiURL: process.env.NEXT_PUBLIC_API_URL,
  graphqlURL: process.env.NEXT_PUBLIC_GRAPHQL_URL,
  cartCookieName: process.env.NEXT_PUBLIC_CART_COOKIE_NAME,
  clickScriptURL: process.env.NEXT_PUBLIC_CLICK_SCRIPT_URL,
  clickScriptIntegrity: process.env.NEXT_PUBLIC_CLICK_SCRIPT_INTEGRITY,
  iovationScriptURL: process.env.NEXT_PUBLIC_IOVATION_SCRIPT_URL,
  signInURL: process.env.NEXT_PUBLIC_ULA_SIGNIN_URL,
  mySparkDigitalSignInURL: process.env.NEXT_PUBLIC_MY_SPARK_DIGITAL_SIGNIN_URL,
  cdpURL: process.env.NEXT_PUBLIC_CDP_URL,
  trackingURL: process.env.NEXT_PUBLIC_TRACKING_URL,
  isDevelopmentEnvironment: process.env.NEXT_PUBLIC_IS_DEVELOPMENT_ENVIRONMENT,
  basePath: process.env.NEXT_PUBLIC_BASE_PATH,
  /* All env vars below will intentionally not be available in the client as
   * they are not prefixed with NEXT_PUBLIC */
  ocpGraphqlURL: process.env.NEXT_PUBLIC_OCP_GRAPHQL_URL,
  // eslint-disable-next-line no-underscore-dangle
  _buildID: process.env._buildId,
  hCaptchaKey: process.env.NEXT_PUBLIC_H_CAPTCHA_KEY,
  errorRedirectDisabled:
    process.env.NEXT_PUBLIC_ERROR_REDIRECT_DISABLED === 'true',
  wwwUrl: process.env.NEXT_PUBLIC_WWW_URL,
};
